module.exports = __webpack_public_path__ + "media/images/game/how_it_works/rozpocet-48876100804d08f31645015437f3c869.png";